export interface Disk {
  id: string;
  label: string;
  volumeName: string | null;
  volumeUuid: string | null;
  totalSize: number | null;
  usedSize: number | null;
  fileCount: number;
  scannedAt: string;
  scannedBy: string | null;
  notes: string | null;
  createdAt: string;
}

export interface DiskRow {
  id: string;
  label: string;
  volume_name: string | null;
  volume_uuid: string | null;
  total_size: number | null;
  used_size: number | null;
  file_count: number;
  scanned_at: string;
  scanned_by: string | null;
  notes: string | null;
  created_at: string;
}

export interface FileEntry {
  id: number;
  diskId: string;
  path: string;
  name: string;
  parentPath: string | null;
  isDirectory: boolean;
  extension: string | null;
  sizeBytes: number | null;
  createdAtFs: string | null;
  modifiedAtFs: string | null;
}

export interface SearchResultRow {
  id: number;
  diskId: string;
  diskLabel: string;
  path: string;
  name: string;
  parentPath: string | null;
  isDirectory: boolean;
  extension: string | null;
  sizeBytes: number | null;
  modifiedAtFs: string | null;
}

export interface SearchResponse {
  total: number;
  rows: SearchResultRow[];
  tookMs: number;
}

export interface DiskAggregateRow {
  diskId: string;
  diskLabel: string;
  diskScannedAt: string | null;
  fileCount: number;
  totalSize: number;
  lastModified: string | null;
}

export interface DiskAggregateResponse {
  rows: DiskAggregateRow[];
  total: number;
  tookMs: number;
}

export interface TreeNode {
  name: string;
  path: string;
  isDirectory: boolean;
  sizeBytes: number | null;
  modifiedAtFs: string | null;
}

export type ScanStatus = "idle" | "preparing" | "scanning" | "uploading" | "completed" | "failed" | "cancelled";

export interface ScanProgressEvent {
  filesScanned: number;
  directoriesScanned: number;
  bytesScanned: number;
  currentPath: string | null;
  recentPaths: string[];
}

export const diskFromRow = (r: DiskRow): Disk => ({
  id: r.id,
  label: r.label,
  volumeName: r.volume_name,
  volumeUuid: r.volume_uuid,
  totalSize: r.total_size,
  usedSize: r.used_size,
  fileCount: r.file_count,
  scannedAt: r.scanned_at,
  scannedBy: r.scanned_by,
  notes: r.notes,
  createdAt: r.created_at,
});
